import { TEMPLATE_TYPES } from './consts'

export const getBidfoodTemplate = templates =>
  (templates || []).find(({ type }) => type === TEMPLATE_TYPES.BIDFOOD)

export const isAutomatic = type => type === TEMPLATE_TYPES.BIDFOOD
